import { DrawerHandle } from '@progress/kendo-react-layout';

import { RefObject, useCallback, useEffect, useState } from 'react';
import { useAppDispatch } from './redux';
import { toggleSidebar } from '../store/slices/layout.slice';

export function useSidebarOpen(componentRef: RefObject<DrawerHandle>) {
  const dispatch = useAppDispatch();
  const [canTrigger, setCanTrigger] = useState(true);

  const clickHandler = useCallback(() => {
    setCanTrigger(false);
    setTimeout(() => {
      setCanTrigger(true);
    }, 500);
  }, []);

  const mouseOverHandler = useCallback(() => {
    dispatch(toggleSidebar(true));
  }, [dispatch]);

  const mouseLeaveHandler = useCallback(() => {
    dispatch(toggleSidebar(false));
  }, [dispatch]);

  useEffect(() => {
    const comp = componentRef.current?.element?.querySelector('.k-widget');

    if (comp) {
      comp.addEventListener('mouseenter', mouseOverHandler);

      comp.addEventListener('mouseleave', mouseLeaveHandler);

      comp.addEventListener('click', clickHandler);
    }

    return () => {
      comp?.removeEventListener('mouseenter', mouseOverHandler);

      comp?.removeEventListener('mouseleave', mouseLeaveHandler);

      comp?.removeEventListener('click', clickHandler);
    };
  }, [
    dispatch,
    canTrigger,
    setCanTrigger,
    componentRef,
    clickHandler,
    mouseOverHandler,
    mouseLeaveHandler,
  ]);
}
